import Icon24 from 'builder/components/Icon'
import { useI18n } from 'builder/hooks/useI18n'

import { HeaderButton } from '../Banners/HeaderButton/HeaderButton'
import { TRANSLATION } from './constants'
import { useResumeWriting } from './hooks/useResumeWriting'

export const ResumeWritingButton = () => {
  const { i18n } = useI18n()
  const { handleResumeWritingButton } = useResumeWriting()

  return (
    <HeaderButton
      type="resume_writing"
      onClick={handleResumeWritingButton}
      text={i18n.t(`${TRANSLATION}.actions.resume_writing`)}
      icon={<Icon24.Chat />}
      tooltip={i18n.t(`${TRANSLATION}.tooltip`)}
    />
  )
}
